



















































































































































import { Component, Vue } from 'vue-property-decorator';
import { currencyFormat } from '@/vue-app/utils/currency';
import AccountBalanceViewModel
  from '../../view-models/components/kuspit-dashboard/account-balance-view-model';
import LoadingDataCard from '@/vue-app/components/home-dashboard/LoadingDataCard.vue';
import DepositAccountInfo
  from '@/vue-app/components/kuspit-dashboard/deposits/DepositsAccountInfo.vue';
import Withdrawal from '@/vue-app/components/kuspit-dashboard/withdrawals/Withdrawal.vue';

@Component({
  name: 'AccountBalance',
  components: {
    LoadingDataCard,
    EditReminder: () => import('./edit-reminder/EditReminder.vue'),
    DepositAccountInfo,
    Withdrawal,
  },
  filters: { currencyFormat },
})
export default class AccountBalance extends Vue {
  account_balance_view_model = Vue.observable(new AccountBalanceViewModel());

  refreshMovements() {
    this.$emit('refreshMovements');
  }

  created() {
    this.account_balance_view_model.initialize();
  }
}
